import { Link } from '@mui/material';
import { ReactNode } from 'react';

const API_DOCS_BASE_URL = 'https://dailycontrol.com/api_docs#/paths';

export const API_DOCS_URLS = {
  entities: `${API_DOCS_BASE_URL}/entities/get`,
  entitiesBatch: `${API_DOCS_BASE_URL}/entities_batch/post`,
  monitoring: `${API_DOCS_BASE_URL}/monitoring/post`,
  entityEvidences: `${API_DOCS_BASE_URL}/entities-id--evidences/get`,
};

/** External link styled to sit inside a tooltip, meant for <Trans> components */
const TooltipLink = ({
  href,
  children,
}: {
  href: string;
  // Filled in by <Trans> with the text between the link tags
  children?: ReactNode;
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    color="inherit"
    sx={{ fontWeight: 600 }}
  >
    {children}
  </Link>
);

export default TooltipLink;
